/**
 * Eps to Figma — thin wrapper around the shared ImporterFlow.
 */

import { ImporterFlow } from '@figma-importers/ui';
import { useImportStore } from './store/importStore';
import { ModePicker } from './components/ModePicker';

function App() {
  return (
    <ImporterFlow
      store={useImportStore}
      config={{
        app: 'eps-to-figma',
        title: 'Eps to Figma',
        subtitle: 'Import .eps artwork as editable layers or images',
        accept: '.eps',
        dropHint: 'Drop an .eps to begin',
        dropSubhint: 'We’ll turn it into a Figma design with editable layers, text and colors.',
        footerLabel: 'EPS → Figma',
        importLabel: 'Import',
        settings: <ModePicker />,
      }}
    />
  );
}

export default App;
